/**
 * Created by boaz on 28/07/16.
 */
'use strict';
import React, {Component} from 'react';
import {Link} from 'react-router';
import {observer} from 'mobx-react';


import Footer from '../components/Footer';

@observer(['state','actions'])
export default class Main extends Component {
    componentWillMount() {
        this.props.actions.auth.updateUserData();
    }
    render() {
        let welcome;
        // if (this.props.actions.auth.isLogged()) {
        //     welcome = <h2>User {this.props.state.userData.email} is logged</h2>;
        // }
        return (
            <div>
                
                {welcome}
                {this.props.children}
                <Footer></Footer>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/js/pages/Main.js